<template>
  <div class='step5'>
    <a-row type='flex' :gutter='24'>
      <a-col flex='3' style='width: 0'>
<!--        <p v-for='(filter, fi) in model.filterList' :key="`${fi}`">-->
<!--          <a-space :size='12'>-->
<!--            <a-select v-if='!(fi ===0 )' v-model='filter.relation' style='width: 100px'>-->
<!--              <a-select-option value='and'>且</a-select-option>-->
<!--              <a-select-option value='or'>或</a-select-option>-->
<!--            </a-select>-->
<!--            <a-select placeholder='请选择数据源' v-model='filter.itemId' style='width: 400px'>-->
<!--              <a-select-option :key="fii2" v-for="(formItem22,fii2) in model.itemList" :value="formItem22.formItemId">{{formItem22.name}} </a-select-option>-->
<!--            </a-select>-->
<!--            <a-select v-model='filter.con' style='width: 120px'>-->
<!--              <a-select-option value='<'>小于</a-select-option>-->
<!--              <a-select-option value='>'>大于</a-select-option>-->
<!--              <a-select-option value='=='>等于</a-select-option>-->
<!--              <a-select-option value='!='>不等于</a-select-option>-->
<!--              <a-select-option value='<='>小于等于</a-select-option>-->
<!--              <a-select-option value='>='>大于等于</a-select-option>-->
<!--              <a-select-option value='in'>包含</a-select-option>-->
<!--            </a-select>-->
<!--            &lt;!&ndash;<a-input v-model='filter.value' style='width: 200px'></a-input>&ndash;&gt;-->
<!--            <a-auto-complete-->
<!--              v-model="filter.value"-->
<!--              style="width: 400px"-->
<!--            >-->
<!--              <template #dataSource>-->
<!--                <a-select-option :value="formItem.name"  v-for="(formItem,fii) in model.itemList" :key="fii">{{formItem.name}}</a-select-option>-->
<!--              </template>-->
<!--            </a-auto-complete>-->
<!--            <a-icon type="plus-circle" @click='addCondition({})'/>-->
<!--            <a-icon v-if='!(fi ===0)' type="close" @click='removeCondition(fi)'/>-->
<!--          </a-space>-->
<!--        </p>-->
        <a-card>
          <a-row type='flex' :gutter='12'>
            <a-col flex='1' style='width: 0'>
              <a-space :size='12'>
                <label>运算符：</label>
                <a-button size='small' type='text' @click='write'>\n</a-button>
                <a-button size='small' type='text' @click='write'>+</a-button>
                <a-button size='small' type='text' @click='write'>-</a-button>
                <a-button size='small' type='text' @click='write'>*</a-button>
                <a-button size='small' type='text' @click='write'>/</a-button>
                <a-button size='small' type='text' @click='write'>%</a-button>
                <a-button size='small' type='text' @click='write'>(</a-button>
                <a-button size='small' type='text' @click='write'>)</a-button>
                <a-button size='small' type='text' @click='write'>e</a-button>
                <a-button size='small' type='text' @click='write'>^</a-button>
                <a-button size='small' type='text' style="margin-left: 20px" @click='sumAll'>sum(all)</a-button>
                <a-button size='small' type='text' style="margin-left: 5px" @click='strAll'>str()</a-button>
              </a-space>
            </a-col>
            <!--<a-col flex='350px' >-->
            <!--公式是否只解析，不进行计算：-->
            <!--<a-radio-group v-model='model.onlyParse' >-->
            <!--<a-radio value="1">是</a-radio>-->
            <!--<a-radio value="0">否</a-radio>-->
            <!--</a-radio-group>-->
            <!--</a-col>-->
<!--            <a-col flex='60px' >-->
<!--              <a-button size='small' type='primary' @click='editHandle()'>{{!edit ? '编辑' : '确定'}}</a-button>-->
<!--            </a-col>-->
          </a-row>
          <a-divider style='margin: 8px 0'/>
          <a-textarea v-model='model.formula'  :rows="30"></a-textarea>

          <div class='operational-character'>

          </div>
        </a-card>
      </a-col>
      <a-col flex='2' style='width: 0'>
        <a-card>
          <div class='data-source-container-title'>数据源</div>
          <div>
            <div v-for="(formItem,fii) in model.itemList" :key="fii" style="margin-top: 10px">
              <a-button type="primary"  @click='write'>{{formItem.name}}</a-button>
<!--              <a-button type="primary" @click='addCondition(formItem)'>{{formItem.name}}</a-button>-->
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'Step4',
  data() {
    return {
      model:{},
      edit:true,
    }
  },
  methods: {
    write(e) {
      let text = e.target.innerText
      if(text==='\\n'){
        text='\n'
      }
      if ( text) {
        this.$set(this.model, 'formula', (this.model.formula||'') + text )
      }
    },
    sumAll(){
      let text = '';
      this.model.itemList.forEach((item,index)=>{
        text += item.name
        if(index < this.model.itemList.length-1){
          text+='+\n'
        }
      })
      this.$set(this.model, 'formula', (this.model.formula||'') + text )
    },
    strAll(){
      let text = '';
      this.model.itemList.forEach((item,index)=>{
        text += '"'+item.name+'"'
        if(index < this.model.itemList.length-1){
          text+='+\n'
        }
      })
      this.$set(this.model, 'formula', (this.model.formula||'') + text )
    },
    editHandle() {
      // todo 需要校验
      this.edit = !this.edit
    },
    test(filter){
    },
    view(model){
      model.filterList = model.filterList || []
      this.model = JSON.parse(JSON.stringify(model))
      if(model.id){

      }else{
        model.itemList.forEach((item,index)=>{
          if(index===0){
            this.addCondition(item)
          }
        })
      }

    },
    addCondition(formItem) {
      this.model.filterList.push({
        itemId:formItem.formItemId,
      })
    },
    removeCondition(i) {
      if (this.model.filterList.length >= 1) {
        this.model.filterList.splice(i, 1)
      }
    },
    validate() {
      // if(this.edit){
      //   this.$message.warning('请点击公式编辑的“确定”按钮，完成编辑')
      //   return false
      // }
      // if(this.model.filterList && this.model.filterList.length>=0){
      //   let error = false
      //   this.model.filterList.forEach((item,index)=>{
      //     if(error){
      //       return
      //     }
      //     if(!item.value || !item.con || !item.field){
      //       error = true
      //     }
      //     if(index>0 &&  !item.relation){
      //       error = true
      //     }
      //   })
      //   if(error){
      //     this.$message.warning('请填写完整条件')
      //     return false
      //   }
      // }
      if(!this.model.formula){
        this.$message.warning('请填写公式')
        return false
      }
      //  可跳过,无需验证
      return true
    },
    /**
     * 当前步骤表单验证逻辑
     */
    // validate() {
    //   //  可跳过,无需验证
    //   let error = false
    //   this.model.itemList.forEach((item,ii) =>{
    //     if(error){
    //       return
    //     }
    //     if(item.filterList && item.filterList.length>0){
    //       item.filterList.forEach((filter,fi)=>{
    //         if(error){
    //           return
    //         }
    //         if(!(ii===0 && fi===0)){
    //           if(!filter.relation){
    //             this.$message.warning('请把条件填写完整2')
    //             error = true
    //           }
    //         }
    //         if(!error &&
    //           (
    //             !filter.itemId
    //             || !filter.con
    //             || !filter.value
    //           )
    //         ){
    //           this.$message.warning('请把条件填写完整1')
    //           error = true
    //         }
    //       })
    //     }
    //   })
    //   let sortNum = 1
    //   this.model.itemList.forEach((item,ii) =>{
    //     if(item.filterList && item.filterList.length>0){
    //       item.filterList.forEach((filter,fi)=>{
    //         filter.sortNum = sortNum++
    //       })
    //     }
    //   })
    //   return !error
    // },

  }
}
</script>

<style scoped>
.data-source-container-title {
  border-left: 4px solid rgb(34, 144, 255);
  padding-left: 8px;
  font-size: 18px;
  font-weight: bold;
  background: #F8F8F8;
  margin-bottom: 8px;
}

.ant-row-flex .ant-card {
 margin: 20px 0;
}

</style>
